/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Seconds_UnitInputs */



/**
* | output |
* | --- |
* | "sec" |
*
* @param {Event_Metrics_Seconds_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_seconds_unit = /** @type {((inputs?: Event_Metrics_Seconds_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Seconds_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("s")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekunde")
	if (locale === "it") return /** @type {LocalizedString} */ ("secondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("сек")
	if (locale === "es") return /** @type {LocalizedString} */ ("segundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("秒")
	if (locale === "ja") return /** @type {LocalizedString} */ ("秒")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेकंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("seg")
	return /** @type {LocalizedString} */ ("sec")
});